/* External dependencies */
import { filter, switchMap } from 'rxjs';

/* Local dependencies */
import { getClient } from '../../../../clients/bts';
import {
  createConsigneeGoodsSpecError,
  createConsigneeGoodsSpecSucceeded,
} from './actions';
import { createConsigneeGoodsSpecificationMutation } from './mutation';
import {
  CreateConsigneeGoodsSpecificationActionTypes,
  CreateConsigneeGoodsSpecRequest,
} from './types';

export function createConsigneeGoodsSpecificationEpic(action$) {
  return action$.pipe(
    filter(
      (action: CreateConsigneeGoodsSpecRequest) =>
        action.type ===
        CreateConsigneeGoodsSpecificationActionTypes.CREATE_CONSIGNEE_GOODS_SPEC_REQUEST,
    ),
    switchMap((action: CreateConsigneeGoodsSpecRequest) =>
      createConsigneeGoodsSpecification(action)
        .then(createConsigneeGoodsSpecSucceeded)
        .catch(createConsigneeGoodsSpecError),
    ),
  );
}

async function createConsigneeGoodsSpecification(
  action: CreateConsigneeGoodsSpecRequest,
) {
  const { input } = action;
  const graphQLClient = await getClient();

  const {
    data: { createConsigneeGoodsSpecification: specification },
  } = await graphQLClient.mutate({
    mutation: createConsigneeGoodsSpecificationMutation,
    variables: { input },
  });

  return specification;
}
